import { render, staticRenderFns } from "./SystemInfo.vue?vue&type=template&id=641dcde5&scoped=true&"
import script from "./SystemInfo.vue?vue&type=script&lang=js&"
export * from "./SystemInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641dcde5",
  null
  
)

export default component.exports